module.exports = __webpack_public_path__ + "static/img/manual-19.a5f8a97.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/manual-19.png
// module id = jqEW
// module chunks = 4